export const MAINTENANCE_FORWARDING_STEP_LABELS: Record<string, string> = {
  checkin: "Check-in",
  establishment_choice: "Escolha de estabelecimento",
  financial_review: "Análise Financeira",
  directive: "Encaminhamento",
  fiscal_assessment: "Recolha de Notas",
  checkout: "Check-out",
};

export const MAINTENANCE_FORWARDING_ENTRY_TYPE_LABELS: Record<string, Record<string, string>> = {
  checkin_entry_labels: {
    "Maintenance::Transport::AutoEntry": "Auto-locomoção",
    "Maintenance::Transport::EstablishmentEntry": "Recolha do estabelecimento",
  },
  checkout_entry_labels: {
    "Maintenance::Transport::AutoEntry": "Auto-locomoção",
    "Maintenance::Transport::EstablishmentEntry": "Recolha do estabelecimento",
  },
  establishment_choice_entry_labels: {
    "Maintenance::EstablishmentChoice::ManualEntry": "Escolha Direta",
    "Maintenance::EstablishmentChoice::AuctionEntry": "Leilão",
  },
  financial_review_entry_labels: {
    "Maintenance::FinancialReview::SimpleEntry": "Analise Financeira",
  },
  fiscal_assessment_entry_labels: {
    "Maintenance::FiscalAssessment::SimpleEntry": "Recolha de Nota",
  },
  directive_entry_labels: {
    "Maintenance::Directive::DiagnosticEntry": "Diagnóstico e Orçamento",
    "Maintenance::Directive::ExecutionEntry": "Execução",
    "Maintenance::Directive::ScrapEntry": "Desfazimento",
  },
};

export const maintenanceForwardingEntryTypeLabels = (): Record<string, string> =>
  Object.values(MAINTENANCE_FORWARDING_ENTRY_TYPE_LABELS).reduce(
    (labels, group) => ({ ...labels, ...group }),
    {} as Record<string, string>,
  );

export const maintenanceForwardingStepLabel = (step?: string | null): string =>
  (step && MAINTENANCE_FORWARDING_STEP_LABELS[step]) || "--";

export const maintenanceForwardingEntryTypeLabel = (entryType?: string | null): string =>
  (entryType && maintenanceForwardingEntryTypeLabels()[entryType]) || "--";
